const messages = {
    accountBox: {
        title: "Valdymo skydelis",
        description: "Greitai stebėkite savo akcijas ir taškus.",
        button: "ATIDARYTI VALDYMO SKYDELĮ",
    },
};

export default {
    messages,
};
